/*
  LD Garantie – "scroll to buy" enhancement.
  Links with [data-ld-scroll-to-buy] scroll to the offer on the current page and move keyboard
  focus there. Order of targets:
  1. the selectors in the link's data-ld-scroll-selector (comma-separated, first rendered match
     wins), e.g. the Kaching bundle picker or the #formule anchor;
  2. the product's add-to-cart button.
  When nothing is found, the link's normal href is followed (progressive enhancement, works
  without JS).
*/
(function () {
  if (window.ldGuaranteeReady) return;
  window.ldGuaranteeReady = true;

  var BUY_SELECTORS = [
    '[data-ld-buy-target]',
    '#MainContent product-info button[name="add"]',
    '#MainContent button[name="add"]',
    '#MainContent form[action$="/cart/add"] [type="submit"]'
  ];

  function isRendered(node) {
    return node.offsetParent !== null || node.getClientRects().length > 0;
  }

  function findFirst(selectors, skipInside) {
    for (var i = 0; i < selectors.length; i++) {
      var selector = selectors[i].trim();
      if (!selector) continue;
      var nodes;
      try {
        nodes = document.querySelectorAll(selector);
      } catch (e) {
        continue; // invalid selector typed in the theme editor
      }
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (skipInside && node.closest(skipInside)) continue;
        if (isRendered(node)) return node;
      }
    }
    return null;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    var header = document.querySelector('sticky-header') ? document.querySelector('.section-header') : null;
    return header ? header.offsetHeight : 0;
  }

  function focusTarget(target) {
    var focusable = target.matches('a[href], button, input, select, textarea, [tabindex]') ? target : null;
    if (!focusable) {
      target.setAttribute('tabindex', '-1');
      focusable = target;
    }
    try {
      focusable.focus({ preventScroll: true });
    } catch (e) {
      focusable.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-ld-scroll-to-buy]') : null;
    if (!link) return;

    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    var custom = (link.getAttribute('data-ld-scroll-selector') || '').split(',');
    var offer = findFirst(custom, '[data-ld-scroll-to-buy]');

    if (offer) {
      event.preventDefault();
      var top = window.pageYOffset + offer.getBoundingClientRect().top - headerOffset() - 16;
      window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: behavior });
      focusTarget(offer);
      return;
    }

    var target = findFirst(BUY_SELECTORS, '[data-ld-scroll-to-buy]');
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: behavior, block: 'center' });
    focusTarget(target);
  });
})();
